"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("@fluentui/react");
var axios_1 = __importDefault(require("axios"));
var FileSizeHelper_1 = require("../../helpers/FileSizeHelper");
require("./FileUpload.scss");
exports.FileUpload = function (props) {
    var fileInput = react_1.useRef(null);
    var extensionFilter = props.extensionFilter, labels = props.labels;
    var _a = react_1.useState(''), progressLabel = _a[0], setProgressLabel = _a[1];
    var _b = react_1.useState(''), filename = _b[0], setFilename = _b[1];
    var _c = react_1.useState(0), fileSize = _c[0], setFilesize = _c[1];
    var _d = react_1.useState(0), progressPercent = _d[0], setProgressPercent = _d[1];
    var onChangedFile = function (ev) {
        var _a;
        if (((_a = ev.currentTarget.files) === null || _a === void 0 ? void 0 : _a.length) === 1) {
            setFilename(ev.currentTarget.files[0].name);
            setFilesize(ev.currentTarget.files[0].size);
        }
        else {
            setFilename('');
            setFilesize(0);
        }
        setProgressLabel('');
        setProgressPercent(0);
    };
    var onProgress = function (e) {
        if (e.total !== 0) {
            var progress = e.loaded / e.total;
            setProgressPercent(progress);
            if (progress === 100) {
                setProgressLabel(props.labels.transfertCompleted);
            }
            setProgressLabel(Math.round(progress * 100) + " %");
        }
    };
    var uploadFile = function (formdata) { return __awaiter(void 0, void 0, void 0, function () {
        var headers, result, exception_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    headers = void 0;
                    if (props.bearerToken) {
                        headers = {
                            'Content-Type': 'multipart/form-data',
                            Authorization: "Bearer " + props.bearerToken,
                        };
                    }
                    else {
                        headers = {
                            'Content-Type': 'multipart/form-data',
                        };
                    }
                    return [4 /*yield*/, axios_1.default.post(props.postUrl, formdata, {
                            headers: headers,
                            onUploadProgress: onProgress,
                        })];
                case 1:
                    result = _a.sent();
                    if (result.status === 200) {
                        setProgressPercent(1);
                        setProgressLabel(props.labels.transfertCompleted);
                        if (props.onCompleted) {
                            props.onCompleted();
                        }
                    }
                    else {
                        throw new Error("httpResult = " + result.status + ", " + result.statusText);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    exception_1 = _a.sent();
                    if (props.showErrorDetails) {
                        setProgressLabel(props.labels.transfertError + " - " + exception_1.message);
                    }
                    else {
                        setProgressLabel(props.labels.transfertError);
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSent = function () {
        var _a, _b, _c;
        var files = (_a = fileInput === null || fileInput === void 0 ? void 0 : fileInput.current) === null || _a === void 0 ? void 0 : _a.files;
        if (files && files.length > 0) {
            if ((_b = fileInput.current) === null || _b === void 0 ? void 0 : _b.form) {
                uploadFile(new FormData((_c = fileInput.current) === null || _c === void 0 ? void 0 : _c.form));
            }
        }
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("form", { className: "fileUploadComponent" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("input", { type: "file", name: "file", multiple: false, accept: extensionFilter, ref: fileInput, onChange: onChangedFile })),
            react_1.default.createElement("div", { className: "buttons" },
                react_1.default.createElement(react_2.PrimaryButton, { disabled: progressPercent > 0 && progressPercent < 1, onClick: function () {
                        if (fileInput.current) {
                            fileInput.current.click();
                        }
                    } }, labels.selectFile),
                react_1.default.createElement(react_2.PrimaryButton, { disabled: filename === '' || progressPercent !== 0, onClick: onSent }, labels.sendFile))),
        filename !== '' && (react_1.default.createElement(react_2.ProgressIndicator, { label: filename + " (" + FileSizeHelper_1.FileSizeToString(fileSize) + ")", description: progressLabel, percentComplete: progressPercent }))));
};
//# sourceMappingURL=FileUpload.js.map